import { defineMessages } from 'react-intl';

export default defineMessages({
  scanning: {
    id: 'cboard.components.Settings.Scanning.scanning',
    defaultMessage: 'Scanning'
  },
  enable: {
    id: 'cboard.components.Settings.Scanning.enable',
    defaultMessage: 'Enable'
  },
  enableSecondary: {
    id: 'cboard.components.Settings.Scanning.enableSecondary',
    defaultMessage: 'Start scanning boards immediately'
  },
  delay: {
    id: 'cboard.components.Settings.Scanning.delay',
    defaultMessage: 'Time delay'
  },
  delaySecondary: {
    id: 'cboard.components.Settings.Scanning.delaySecondary',
    defaultMessage: 'Time between two consecutive scanning highlights'
  },
  method: {
    id: 'cboard.components.Settings.Scanning.method',
    defaultMessage: 'Scan method'
  },
  methodSecondary: {
    id: 'cboard.components.Settings.Scanning.methodSecondary',
    defaultMessage: 'Method to be used for board exploration'
  },
  seconds: {
    id: 'cboard.components.Settings.Scanning.seconds',
    defaultMessage: '{value} seconds'
  },
  automatic: {
    id: 'cboard.components.Settings.Scanning.automatic',
    defaultMessage: 'Automatic'
  },
  manual: {
    id: 'cboard.components.Settings.Scanning.manual',
    defaultMessage: 'Manual'
  },
  scannerHowToDeactivate: {
    id: 'cboard.components.Settings.Scanning.scannerHowToDeactivate',
    defaultMessage: 'Press Escape 4 times to deactivate Scanner.'
  },
  scannerManualStrategy: {
    id: 'cboard.components.Settings.Scanning.scannerManualStrategy',
    defaultMessage:
      'Scanner advances with space bar key, press enter to select an item.'
  },
  scannerAutomaticStrategy: {
    id: 'cboard.components.Settings.Scanning.scannerAutomaticStrategy',
    defaultMessage:
      'Scanner will iterate over elements, press any key to select them.'
  },
  eyeControl: {
    id: 'cboard.components.Settings.Scanning.eyeControl',
    defaultMessage: 'Eye control'
  },
  eyeControlEnable: {
    id: 'cboard.components.Settings.Scanning.eyeControlEnable',
    defaultMessage: 'Select with a blink'
  },
  eyeControlEnableSecondary: {
    id: 'cboard.components.Settings.Scanning.eyeControlEnableSecondary',
    defaultMessage:
      'Use the webcam to select the highlighted item with a deliberate blink. All processing happens on your device.'
  },
  eyeControlRequiresScanning: {
    id: 'cboard.components.Settings.Scanning.eyeControlRequiresScanning',
    defaultMessage: 'Enable scanning first to use eye control.'
  },
  eyeControlDwell: {
    id: 'cboard.components.Settings.Scanning.eyeControlDwell',
    defaultMessage: 'Blink hold time'
  },
  eyeControlDwellSecondary: {
    id: 'cboard.components.Settings.Scanning.eyeControlDwellSecondary',
    defaultMessage: 'How long to keep the eyes closed to make a selection'
  },
  eyeControlSensitivity: {
    id: 'cboard.components.Settings.Scanning.eyeControlSensitivity',
    defaultMessage: 'Sensitivity'
  },
  eyeControlSensitivitySecondary: {
    id: 'cboard.components.Settings.Scanning.eyeControlSensitivitySecondary',
    defaultMessage: 'How strongly the eyes must close to count as a blink'
  },
  eyeControlShowPreview: {
    id: 'cboard.components.Settings.Scanning.eyeControlShowPreview',
    defaultMessage: 'Show camera preview'
  },
  eyeControlShowPreviewSecondary: {
    id: 'cboard.components.Settings.Scanning.eyeControlShowPreviewSecondary',
    defaultMessage: 'Display a small camera window with blink feedback'
  },
  eyeControlMilliseconds: {
    id: 'cboard.components.Settings.Scanning.eyeControlMilliseconds',
    defaultMessage: '{value} ms'
  },
  eyeControlSensitivityLow: {
    id: 'cboard.components.Settings.Scanning.eyeControlSensitivityLow',
    defaultMessage: 'Low'
  },
  eyeControlSensitivityMedium: {
    id: 'cboard.components.Settings.Scanning.eyeControlSensitivityMedium',
    defaultMessage: 'Medium'
  },
  eyeControlSensitivityHigh: {
    id: 'cboard.components.Settings.Scanning.eyeControlSensitivityHigh',
    defaultMessage: 'High'
  }
});
